import {
  Environment,
  devAgoraAppId,
  devApiUrl,
  devFirebaseConfig,
  devFirebaseTokenId,
  devFirebaseVapidKey,
  devWsDomain,
  mapTilerKey,
  devFacebookConfigId,
} from ".";

export const environment: Environment = {
  env: "dev",
  production: false,
  firebaseConfig: devFirebaseConfig,
  firebaseVapidKey: devFirebaseVapidKey,
  sentryDsn:
    "https://248a477985200422c4e892971cecf0c0@o1211156.ingest.us.sentry.io/4506969709412352",
  sentryWhitelistHosts: [
    "web-dev.jugl.com",
    /jugl-dev-org-web-rc-\d+-\d+-\d+.netlify.app/g,
  ],
  posthogApiKey: "phc_xBX75uEtVnHb7dDrf9gryebawZaC8NV7RqpL8bC4hAhg",
  // PostHog runs in production only — no capture or replay outside prod/beta
  posthogWhitelistHosts: [],
  apiUrl: devApiUrl,
  wsDomain: devWsDomain,
  firebaseTokenId: devFirebaseTokenId,
  mapTilerKey,
  geocodingKey: atob("QUl6YVN5RFFBMGRkUEl1MGEwcG83U3J5eVRRS3NGMWFaQ1lpMHk4"),
  agoraAppId: devAgoraAppId,
  chatBotToken:
    "PgDUXN.xzYu9E6oWJP0471b4pqnVggJty4oeeL9WePB3s3oV8k/INwkAPj8nnfMwwHeSuc7f/rzAfZHgoZ5LwA==",
  isReCaptchaEnabled: true,
  reCaptchaKey: "6LdMnvopAAAAAID5SLUbjhOfVLc2BDzMlvJPr3nn",
  guestUrl: "https://guest-dev.jugl.com",
  facebookConfigId: devFacebookConfigId,
  featureFlags: {
    maxChatAttachmentsCount: 10,
  },
  demoToken: "",
  instagramClientId: "1428845108206758",
  chatBotUrl: "https://jugl-chat-bot-dev.netlify.app",
  liveChatUrl: "https://jugl-live-chat-dev.netlify.app",
  escapeChatChars: true,
};
